import { type IntlShape } from 'react-intl'

import {
  type ContactFormLoggedOutNotificationType,
  directContactFormSubjectPolicyGetByTranslatedSubject,
} from '../../direct-contact'

export type DirectContactFormLoggedOutNotificationType =
  ContactFormLoggedOutNotificationType

export const directContactFormAccessorGetLoggedOutNotification = ({
  intl,
  isLoggedIn,
  subject,
}: {
  intl: IntlShape
  isLoggedIn: boolean
  subject: string
}): {
  loggedOutNotificationType?: DirectContactFormLoggedOutNotificationType
} => {
  if (isLoggedIn) {
    return {
      loggedOutNotificationType: undefined,
    }
  }

  return {
    loggedOutNotificationType:
      directContactFormSubjectPolicyGetByTranslatedSubject({ intl, subject })
        .policy.loggedOutNotification,
  }
}
